import styled from 'styled-components'
import Modal from '@/components/common/Modal'
import { device } from '@/common/constants/device'
import { ProfileModalTitle } from '@/components/Profile/ProfileStyled'
import BaseButtonClose from '@/components/common/BaseButtonClose'
import Button from '@/components/ui/Button'
import React from 'react'
import Text from '@/components/common/Text'
import { close } from '@/store/modalsSlice'
import { useDispatch } from 'react-redux'
import BaseLink from '@/components/common/BaseLink'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { ANALYTIC_OFFER } from '@/common/constants/analytics'
import { OFFER_MODAL_KEY } from '@/components/Creatives/hooks/useOffers'
import { PAYMENT_SOURCE } from '@/common/constants/cookies'
import { useTranslations } from 'next-intl'

const OfferModal = styled(Modal)`
  .modal-content {
    @media ${device.tablet} {
      width: 100%;
    }
  }

  .modal-inner-content {
    padding: 20px;
    z-index: 999;
    @media ${device.tablet} {
      padding: 30px;
    }
  }
`

const OfferModalTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const OfferModalWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
`

const OfferModalForm = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`

const ModalContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  width: 100%;
  gap: 20px;
  margin-top: 12px;
`
const Wrap = styled.div`
  margin-top: 12px;
`

const ModalText = styled.div`
  flex: 1;
`

const ModalImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
`

const BaseLinkWrap = styled(BaseLink)`
  width: 100%;
`

const features = [
  'advanced-filters',
  'unlimited-results',
  'daily-searches',
  'personalized-updates',
  'premium-tools',
  'mobile-apps-analytics',
]

const OffersModal = () => {
  const t = useTranslations('offers')
  const dispatch = useDispatch()
  const trigger = sessionStorage.getItem(OFFER_MODAL_KEY)

  const closeModal = () => {
    dispatch(close())
    userAmplitudeAnalytics.trackEvent(
      `${ANALYTIC_OFFER}_search_banner_close_clicked`,
      { trigger }
    )
  }

  const upgradePlan = () => {
    dispatch(close())
    userAmplitudeAnalytics.trackEvent(
      `${ANALYTIC_OFFER}_search_banner_cta_clicked`,
      { trigger }
    )
    sessionStorage.setItem(PAYMENT_SOURCE, 'session')
  }

  return (
    <OfferModal maxWidth="644" needOffsetHeader>
      <OfferModalForm>
        <OfferModalTop>
          <ProfileModalTitle color="black-russian">
            {t('modal-title')}
          </ProfileModalTitle>
          <BaseButtonClose close={closeModal} />
        </OfferModalTop>
        <ModalContent>
          <ModalText>
            <Text size="20" weight="500">
              {t('missing-out')}
            </Text>
            <Wrap>
              {features.map((feature) => (
                <Text key={feature} size="18" weight="400" color="black">
                  - {t(feature)}
                </Text>
              ))}
            </Wrap>
          </ModalText>
          <ModalImage
            src="/_next_static/premium/premium-intro.svg"
            alt="Upgrade Offer"
          />
        </ModalContent>
        <OfferModalWrap>
          <BaseLinkWrap href="/premium" isChangePath={false}>
            <Button
              size="16"
              isLoading={false}
              filled
              block
              onClick={upgradePlan}
            >
              {t('upgrade-plan')}
            </Button>
          </BaseLinkWrap>
        </OfferModalWrap>
      </OfferModalForm>
    </OfferModal>
  )
}

export default OffersModal
